import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import StudentsListPage from '../components/students/StudentsListPage';
import StudentPage from '../components/StudentPage';
import api from '../services/api';

export default function Students() {
  const { studentId } = useParams();
  const [selectedStudentId, setSelectedStudentId] = useState(studentId || null);
  const [students, setStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await api.get('/students');
        setStudents(response.data.data.students);
      } catch (err) {
        setError('Failed to load students');
        console.error('Failed to fetch students:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStudents();
  }, []);

  useEffect(() => {
    if (studentId) {
      setSelectedStudentId(studentId);
    }
  }, [studentId]);

  const selectedStudent = selectedStudentId 
    ? students.find(student => student.name === selectedStudentId)
    : null;

  if (error) {
    return (
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <div className="text-red-600 dark:text-red-400">{error}</div>
      </div>
    );
  }

  if (!selectedStudent && selectedStudentId) {
    return null;
  }

  return (
    <div className="space-y-6">
      {selectedStudent ? (
        <StudentPage 
          student={selectedStudent} 
          onBack={() => setSelectedStudentId(null)} 
        />
      ) : (
        <StudentsListPage 
          students={students} 
          onSelectStudent={setSelectedStudentId}
          isLoading={isLoading}
        />
      )}
    </div>
  );
}